'use client';
import { useCallback, useState, useEffect } from 'react';

export const useToggle = (
  initialState = false,
  onStateChange: (state: boolean) => void = () => void 0
) => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(() => setState((s) => !s), []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(onStateChange, []);
  useEffect(() => callback(state), [state, callback]);
  return [state, toggle, setState] as [boolean, typeof toggle, typeof setState];
};
